import { io } from 'socket.io-client';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const SOCKET_URL = API_BASE.replace(/\/api\/?$/, '');

let socket = null;

function buildSocket() {
  const token = localStorage.getItem('crm_token');
  return io(SOCKET_URL, {
    transports: ['websocket'],
    autoConnect: false,
    auth: {
      token: token ? `Bearer ${token}` : ''
    }
  });
}

export function getSocket() {
  if (!socket) socket = buildSocket();
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) {
    // Refresh auth token on every (re)connect attempt
    const token = localStorage.getItem('crm_token');
    s.auth = { token: token ? `Bearer ${token}` : '' };
    s.connect();
  }
  return s;
}

export function disconnectSocket() {
  if (socket) socket.disconnect();
}

